
import { VuexModule, Mutation, getModule, Module, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue/store';

@Module({
  namespaced: true,
  name: 'ItiLayoutMenuModule',
  store,
  dynamic: true,
})
class ItiLayoutMenuModule extends VuexModule {
  public visible: boolean = true;

  @Action
  public toggleVisible() {
    this.context.commit('setVisible', !this.visible);
  }

  @Mutation
  public setVisible(newValue: boolean) {
    this.visible = newValue;
  }

}
export default getModule(ItiLayoutMenuModule);
